import { FC } from 'react';
import { Box, Button, HStack, Heading } from '@chakra-ui/react';
import { useNavigate, useParams } from 'react-router-dom';

import { useGetDirectoryByIdQuery } from '../../../services';
import { DirectoryType } from '../../../models';
import { FilesUploader } from '../../../components';

export const SavedDocument: FC = () => {
  const params = useParams();
  const { projectId, directoryId, phaseId } = params;
  const type = params.type || 'all';

  const { data: currentDirectory } = useGetDirectoryByIdQuery(
    Number(directoryId)
  );

  const navigate = useNavigate();

  const navigateToPreviousPage = () => {
    let url = `/projects/${type}/${String(projectId)}/project-details`;

    if (type === 'single-phase') {
      url += `/documents`;
    }
    if (type === 'multiple-phase') {
      url += `/phases/${String(phaseId)}/documents`;
    }

    if (
      currentDirectory?.data.parentDirectory?.directoryTypeEnum !==
      DirectoryType.PROJECT
    )
      url += `/${String(directoryId)}`;
    navigate(url);
  };

  return (
    <Box>
      <HStack justify="space-between" mt="4" mb="12" align="center">
        <Heading color="custom_blue.1" fontSize="2xl">
          Upload Documents
        </Heading>

        <HStack mt={4} justify="end">
          <Button onClick={navigateToPreviousPage}>Cancel</Button>
          {/* <Button
            type="button"
            bg="custom_orange.2"
            _hover={{ bg: 'custom_orange.2' }}
            color="white"
          >
            Save
          </Button> */}
        </HStack>
      </HStack>

      <Box
        w="full"
        p="4"
        boxShadow="0 1px 2px 0 rgba(16, 24, 40, 0.05)"
        borderRadius="md"
        border="1px"
        borderColor="custom_gray.3"
        gap="5"
        mb="5"
      >
        <FilesUploader attachedId={Number(directoryId)} />
      </Box>
    </Box>
  );
};
